import type { TableOptions } from '@tanstack/react-table';
import { useMemo, type PropsWithChildren } from 'react';

import { getMinMaxForGanttColumns } from './GanttChart.js';
import type { DataTableRowData } from '../../row-data-types.js';
import type { TDataTableFeatures } from '../types/features.types.js';

/**
 * Configuration hook for the DataTable Gantt Chart feature.
 * @internal
 */
export function useGanttChart<TData extends DataTableRowData>(
  _props: PropsWithChildren,
  options: TableOptions<TDataTableFeatures, Exclude<TData, unknown>>,
): void {
  const ganttMinMaxValues = useMemo(
    () =>
      getMinMaxForGanttColumns<TDataTableFeatures, Exclude<TData, unknown>>(
        options.data,
        options.columns,
        options.getSubRows,
      ),
    [options.columns, options.data, options.getSubRows],
  );

  // eslint-disable-next-line react-hooks/immutability
  options.state = {
    ...options.state,
    ganttMinMaxValues,
  };
}
